import Login from './Login';
import LoginForm from './LoginForm';

export { Login, LoginForm };

export default Login;
